import {
  Box,
  LinearProgress,
  List,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { blue, green } from "@material-ui/core/colors";
import RegularButton from "components/CustomButtons/Button";
import { animations } from "helpers/animations";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { stopPrint } from "redux/actions/printers/printersActions";
import { useToggle } from "hooks/useToggle";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { restorePrint } from "redux/actions/printers/printersActions";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";
import { statusPrinting } from "redux/reducers/printers/printersReducer";
import { usePrintQueue } from "hooks/usePrintQueue";

export const PrintingSnackbar = React.memo(() => {
  const dispatch = useDispatch();
  const { printQueue, printedQueue } = useSelector(({ printers }) => printers);
  const [show, setShow] = useToggle(true);
  usePrintQueue()
  const handleRemoveFile = (id) => {
    dispatch(stopPrint(id, statusPrinting.CANCELED.status));
  };

  const handleRestorePrint = () => {
    dispatch(restorePrint());
  };

  useEffect(() => {
    let closeSnackbar = setTimeout(() => {
      if (printQueue.length === 0) {
        handleRestorePrint()
      }
    }, 5000);

    return () => {
      clearTimeout(closeSnackbar);
    };
  }, [printQueue])

  return (
    <Box
      className={
        printQueue.length || printedQueue.length
          ? animations.fadeRight
          : animations.fadeOut
      }
      style={{
        width: 320,
        maxHeight: "80vh",
        overflow: "hidden",
        overflowY: "scroll",
        borderRadius: 8,
        backgroundColor: blue[50],
        position: "fixed",
        top: 15,
        right: 15,
        zIndex: 1030,
        transition: "all 0.3s ease-in-out",
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
        animationDelay: "1s",
        padding: 8,
      }}
    >
      {show ? (
        <>
          <List style={{ padding: 1 }}>
            {printQueue.map((print) => (
              <React.Fragment key={print.id}>
                <ListItemText
                  primary={
                    <Typography
                      variant="caption"
                      style={{ color: blue[500], marginRight: 16 }}
                    >
                      {print.fileName}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" style={{ color: blue[500] }}>
                      {print.printLabel}
                      <RegularButton
                        justIcon
                        round
                        color="transparent"
                        onClick={() => handleRemoveFile(print.id)}
                        disabled={print.printing}
                      >
                        <HighlightOffIcon />
                      </RegularButton>
                    </Typography>
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    transition: "all ease .2s",
                  }}
                />
                {print.printing && <LinearProgress color="primary" />}
              </React.Fragment>
            ))}
          </List>
          <List style={{ padding: 1 }}>
            {printedQueue.map((print, i) => (
              <React.Fragment key={print.id + i}>
                <ListItemText
                  primary={
                    <Typography
                      variant="caption"
                      style={{ color: blue[500], marginRight: 16 }}
                    >
                      {print.fileName}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      variant="caption"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 16,
                        color: blue[500],
                      }}
                    >
                      {print.printLabel}
                      {print.status === statusPrinting.PRINTED.status && (
                        <DoneIcon style={{ color: green[300] }} />
                      )}
                    </Typography>
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    transition: "all ease .2s",
                  }}
                />
              </React.Fragment>
            ))}
          </List>
        </>
      ) : (
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 54,
          }}
        >
          <Typography variant="caption" style={{ color: blue[500] }}>
            Archivos en cola: {printQueue.length} / Error: {printedQueue.length}
          </Typography>
        </Box>
      )}
      <RegularButton
        fullWidth
        size="sm"
        color="transparent"
        onClick={
          printQueue.length === 0 && printedQueue.length
            ? handleRestorePrint
            : setShow
        }
        justIcon
        round
        style={{
          position: "absolute",
          top: 10,
          right: 10,
        }}
      >
        {printQueue.length === 0 && printedQueue.length ? (
          <CloseIcon />
        ) : show ? (
          <KeyboardArrowUpIcon style={{ color: blue[800] }} />
        ) : (
          <KeyboardArrowDownIcon style={{ color: blue[800] }} />
        )}
      </RegularButton>
    </Box>
  );
});
